angular
  .module('fca-used')
  .factory('InstallmentsCalculator', installmentsCalculatorService);

installmentsCalculatorService.$inject = ['$http', '$sce', '$httpParamSerializer', 'moment', 'Guid', 'CONFIG', '$window'];

function installmentsCalculatorService($http, $sce, $httpParamSerializer, moment, Guid, CONFIG, $window) {
  var uuid = Guid.newGuid();
  var countryCode = CONFIG.language.id + '_' + CONFIG.market.id.toUpperCase();

  return {
    init: init,
    getMVS: getMVS,
    getMonthlyRate: getMonthlyRate,
    getIframeUrl: getIframeUrl
  };

  function init() {
    uuid = Guid.newGuid();
  }

  function getMVS(vehicle) {
    return vehicle.simType + vehicle.brandCode + vehicle.modelCode;
  }

  function getMonthlyRate(vehicles) {
    if (!angular.isArray(vehicles)) {
      vehicles = [vehicles];
    }
    var params = {
      countryCode: countryCode,
      data: [],
      token: uuid,
      guid: '',
      model: false
    };

    angular.forEach(vehicles, function (vehicle) {
      params.data.push({
        mvs: getMVS(vehicle),
        price: vehicle.priceCurrent,
        priceService: 0,
        pricePromotion: 0,
        age: moment().diff(moment([vehicle.registrationYear, vehicle.registrationMonth - 1, vehicle.registrationDay]), 'M'),
        mileage: vehicle.km,
        fuel: vehicle.fuelCode
      });
    });

    params.data = angular.toJson(params.data);

    var url = $sce.trustAsResourceUrl(CONFIG.installmentsCalculator.api + '/GetFinancingInstallment');

    return $http.jsonp(url, {
      jsonpCallbackParam: 'callback',
      params: params
    }).then(function (response) {
      return response.data.response;
    });
  }

  function getIframeUrl(vehicle) {
    var url = CONFIG.installmentsCalculator.iframe.domain + CONFIG.installmentsCalculator.iframe.path + '?' + $httpParamSerializer({
      mvs: getMVS(vehicle),
      uuid: uuid,
      price: vehicle.priceCurrent,
      lang: countryCode,
      priceService: 0,
      pricePromotion: 0,
      age: moment().diff(moment([vehicle.registrationYear, vehicle.registrationMonth - 1, vehicle.registrationDay]), 'M'),
      mileage: vehicle.km,
      fuel: vehicle.fuelCode,
      data: [],
      /* eslint-disable camelcase */
      opncl_performance: true,
      opncl_advertising: true,
      /* eslint-enable camelcase */
      pricePromotionNoVAT: 0,
      priceNoVAT: 0,
      originUrl: encodeURIComponent($window.location.href),
      dealerCode: vehicle.dealerCode,
      prescoringActive: true,
      vinCode: vehicle.vin
    });
    return $sce.trustAsResourceUrl(url);
  }
}
